import React, { memo } from 'react';
import styled from 'styled-components';
import { DocumentStatus } from '../../../graphql/schema/p4types';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

export const PostedPill = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagSuccess};
  background-color: ${p4Tokens.statusFlagSuccess};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const CreditedPill = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagWarning};
  background-color: ${p4Tokens.statusFlagWarning};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const PendingPill = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagInfo};
  background-color: ${p4Tokens.statusFlagInfo};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

export const DraftPill = styled.div`
  border-radius: 3px;
  border: 1px solid ${p4Tokens.statusFlagBasic};
  background-color: ${p4Tokens.statusFlagBasic};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const DocumentStatusFormatter = ({ value }: { value: DocumentStatus }) => {
  switch (value) {
    case DocumentStatus.Adjustment:
      return <CreditedPill>ADJUSTMENT</CreditedPill>;
    case DocumentStatus.Reconciled:
      return <PostedPill>RECONCILED</PostedPill>;
    case DocumentStatus.Posted:
      return <PostedPill>POSTED</PostedPill>;
    case DocumentStatus.Pending:
      return <PendingPill>PENDING</PendingPill>;
    case DocumentStatus.Credited:
      return <CreditedPill>CREDITED</CreditedPill>;
    case DocumentStatus.Reinvoiced:
      return <CreditedPill>RE-INVOICED</CreditedPill>;
    case DocumentStatus.Reversed:
      return <CreditedPill>REVERSED</CreditedPill>;
    default:
      return <DraftPill>DRAFT</DraftPill>;
  }
};

export default memo(DocumentStatusFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
